import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Children, cloneElement } from 'react';
import rejectNilChildren from '../../../../utils/rejectNilChildren';
const TableHead = ({ className, children, columnDescriptor, hiddenHeader, ...other })=>{
    const markAsHead = (child, index)=>/*#__PURE__*/ cloneElement(child, {
            columnDescriptor,
            isHead: true,
            isLast: index === React.Children.count(children) - 1
        });
    children = rejectNilChildren(children);
    return /*#__PURE__*/ React.createElement("thead", {
        className: cx('Table-header', {
            'Table-header--hidden': hiddenHeader
        }, className),
        ...other
    }, Children.map(children, markAsHead));
};
TableHead.propTypes = {
    /**
	 * Children will be rendered within the `TableHead`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    columnDescriptor: PropTypes.object,
    /**
	 * TableHead is required for table's responsive behaviour (column hiding). So when you want to have responsive table without header you have a way how to define head and hide it.
	 */ hiddenHeader: PropTypes.bool
};
TableHead.displayName = 'TableHead';
export default TableHead;
